import { Injectable } from '@angular/core';
import { FacebookLogin, FacebookLoginResponse } from '@capacitor-community/facebook-login';

@Injectable({
  providedIn: 'root',
})
export class FacebookService {
  async login(): Promise<string> {
    const result: FacebookLoginResponse = await FacebookLogin.login({ permissions: ['email', 'public_profile'] });

    if (result.accessToken) {
      // Retorna o accessToken
      return result.accessToken.token;
    } else {
      throw new Error('Facebook login failed or was cancelled');
    }
  }


  async getUserData(): Promise<any> {
    const result = await FacebookLogin.getProfile<{
      id: string;
      name: string;
      email: string;
      birthday: string;
      first_name: string;
      last_name: string;
      picture: {
        data: {
          url: string;
          height: number;
          width: number;
          is_silhouette: boolean;
        };
      };
    }>({
      fields: [
        'id',
        'name',
        'email',
        'birthday',
        'first_name',
        'last_name',
        'picture.width(800).height(800)',
      ]
    });

    return result;
  }

  async logout(): Promise<void> {
    await FacebookLogin.logout();
  }
}